export class ProcessingStep {
	public id: string;
	public stepId: string;
	public caseId: string;
	public documentId: string;
	public functionId: string;
	public caseName: string;
	public functionName: string;
	public stepParams: any;
	public createdDateTime: string;
	public documentName: string;
	public docExtension: string;
	public pageCount: number;
	public documentSize: number;
	public serverIpAddress?: string;
	public serverInstanceName: string;
}

